import React from "react";

import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";

const RedDotComponentLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "redDot/component" */
      "./RedDotComponent"
    ),
  loading: EmptyComponent
});

export const RedDotComponent = props => {
  return <RedDotComponentLoadable {...props} />;
};
